import { render, staticRenderFns } from "./Extra work.vue?vue&type=template&id=17200673&scoped=true"
import script from "./Extra work.vue?vue&type=script&lang=js"
export * from "./Extra work.vue?vue&type=script&lang=js"
import style0 from "./Extra work.vue?vue&type=style&index=0&id=17200673&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17200673",
  null
  
)

export default component.exports